function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(1)
  },
  group: {
    display: "flex",
    flexDirection: props => {
      return props.direction;
    }
  }
}));

const OptionsBase = (_ref) => {
  let className = _ref.className,
      label = _ref.label,
      _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? false : _ref$inline,
      helperText = _ref.helperText,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "label", "inline", "helperText", "children"]);

  if (inline) {
    props.direction = "row";
  } else {
    props.direction = "column";
  }

  const classes = useStyles(props);
  return React.createElement(FormControl, {
    className: className || classes.root,
    component: "fieldset"
  }, React.createElement(FormLabel, {
    component: "legend"
  }, label), React.createElement("div", {
    className: classes.group
  }, children), helperText && React.createElement(FormHelperText, null, helperText));
};

export default OptionsBase;